import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import MyCropsIcon from "../../assets/Icon/MyCropsIcon.png";
import CustomCard from "../../components/Famer/GenericCard";
import { useNavigate } from "react-router-dom";
import { getPrograms } from "../../api/programs";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadPrograms();
  }, []);

  const loadPrograms = async () => {
    const _programs = await getPrograms();
    setPrograms(_programs);
    setLoading(false);
  };

  const handleAdd = () => {
    navigate("/programs/program/create");
  };

  const handleView = (cropId) => {
    navigate(`/programs/program/${cropId}`);
  };

  const handleEditClick = (cropId) => {
    navigate(`/programs/program/${cropId}`);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: programs.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            // alignItems: "center", // Center items horizontally
          }}
        >
          {programs.length !== 0 && (
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontSize: "30px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {t("My Programs")}
            </Typography>
          )}
          <div
            style={{
              // overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
            }}
          >
            {programs.map((crop) => (
              <CustomCard
                key={crop.id}
                id={crop.id}
                t={t}
                data={{
                  [t("Name")]: crop.name,
                }}
                file={crop.sowing_file}
                handlePrimaryButton={handleView}
                handleEditClick={() => handleEditClick(crop.id)}
                handleDelete={() => alert("Delete is not supported yet")}
                flag={true}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {programs.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={MyCropsIcon}
                  alt="My Crops Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <CustomButton onClick={handleAdd}>
              {t("Create Program")}
            </CustomButton>
            {programs.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t("Your programs will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
    </>
  );
}
